import template from './education_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class EducationHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EducationHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EducationHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EducationHelp',
	dialog_class: EducationHelpPage,
	template: template,
	template_filename: 'translation/dialogs/education_help',
	provider: 'ps'
};
